// extracted by mini-css-extract-plugin
export default {"answer-section":"answer-section_3xvQd","evaluation-wrapper":"evaluation-wrapper_1ky3J"};